import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { PagesContext } from '../store/PagesContext';
import { getItemFromLocalStorage } from 'helpers/localStorage';

import bluePolygon from '../assets/images/svg/blue-polygon.svg';

import Intro from 'routes/decision-trees/components/Intro';

const NsoE = ({ setCurrentPage }) => {
  const continueHandler = () => setCurrentPage('nsoI');

  const [, setLastPage] = useContext(PagesContext);

  useEffect(() => setLastPage(getItemFromLocalStorage('EcameFrom') || 'nsoD'), []);

  return (
    <div className='mw-700 m-auto py-sm-5'>
      <Intro size='middle' background={bluePolygon}>
        <h2 className='my-4'>
          I intend to hold
          <br />
          onto my stocks and
          <br />
          sell at a later date.
        </h2>

        <div className='c-pointer' onClick={continueHandler}>
          Continue &gt;
        </div>
      </Intro>
    </div>
  );
};

NsoE.propTypes = {
  setCurrentPage: PropTypes.func
};

export default NsoE;
